import OnboardingTask from '../components/tasks/OnboardingTask';
import TaskCustom from '../components/tasks/TaskCustom';
import TaskGriefJournaling from '../components/tasks/TaskGriefJournaling';
import TaskGratitudeJournaling from '../components/tasks/TaskGratitudeJournaling';
import TaskHamiltonAnxiety from '../components/tasks/TaskHamiltonAnxiety';
import TaskOpenEnded from '../components/tasks/TaskOpenEnded';
import TaskRealityCheck from '../components/tasks/TaskRealityCheck';
import TaskPhotoJournal from '../components/tasks/TaskPhotoJournal';
import TaskSongOfTheDay from '../components/tasks/TaskSongOfTheDay';
import TaskStepOutside from '../components/tasks/TaskStepOutside';

// Lightweight task registry - just metadata and component references
export const TASK_REGISTRY = {
  'task_001': {
    typeId: 'task_001',
    name: 'Onboarding Task',
    pageTitle: 'Onboarding Task',
    description: 'Provide information to help your therapist understand your background',
    category: 'intake',
    estimatedDuration: 20,
    component: OnboardingTask,
    isActive: true
  },
  'task_003': {
    typeId: 'task_003',
    name: 'Grief Journaling: Daily Awareness',
    pageTitle: 'Daily Awareness',
    description: 'Acknowledge daily grief patterns and emotions without going too deep at once',
    category: 'grief',
    estimatedDuration: 10,
    component: TaskGriefJournaling,
    isActive: true
  },
  'task_004': {
    typeId: 'task_004',
    name: 'Grief Journaling: Understanding Waves',
    pageTitle: 'Understanding Waves',
    description: 'Build awareness of triggers and recurring emotional responses',
    category: 'grief',
    estimatedDuration: 10,
    component: TaskGriefJournaling,
    isActive: true
  },
  'task_005': {
    typeId: 'task_005',
    name: 'Grief Journaling: Positive Memories',
    pageTitle: 'Positive Memories',
    description: 'Balance pain with warmth, encouraging memory connection',
    category: 'grief',
    estimatedDuration: 15,
    component: TaskGriefJournaling,
    isActive: true
  },
  'task_006': {
    typeId: 'task_006',
    name: 'Grief Journaling: Honoring & Forgiveness',
    pageTitle: 'Honoring & Forgiveness',
    description: 'Support release of guilt and foster healing rituals',
    category: 'grief',
    estimatedDuration: 15,
    component: TaskGriefJournaling,
    isActive: true
  },
  'task_007': {
    typeId: 'task_007',
    name: 'Grief Journaling: Coping & Self-Compassion',
    pageTitle: 'Coping & Self-Compassion',
    description: 'Build a personalized "grief toolkit" with coping strategies',
    category: 'grief',
    estimatedDuration: 15,
    component: TaskGriefJournaling,
    isActive: true
  },
  'task_008': {
    typeId: 'task_008',
    name: 'Grief Journaling: Support System',
    pageTitle: 'Support System',
    description: 'Reflect on relationships and help-seeking behaviors',
    category: 'grief',
    estimatedDuration: 10,
    component: TaskGriefJournaling,
    isActive: true
  },
  'task_009': {
    typeId: 'task_009',
    name: 'Grief Journaling: Letters of Grief',
    pageTitle: 'Letters of Grief',
    description: 'Deep emotional processing through letter writing',
    category: 'grief',
    estimatedDuration: 20,
    component: TaskGriefJournaling,
    isActive: true
  },
  'task_010': {
    typeId: 'task_010',
    name: 'Grief Journaling: Moving Forward',
    pageTitle: 'Moving Forward',
    description: 'Focus on meaning-making and acceptance',
    category: 'grief',
    estimatedDuration: 15,
    component: TaskGriefJournaling,
    isActive: true
  },
  'task_011': {
    typeId: 'task_011',
    name: 'Custom Task',
    pageTitle: 'Custom Task',
    description: 'A custom task created by your therapist',
    category: 'custom',
    estimatedDuration: 0,
    component: TaskCustom,
    isActive: false
  },
  'task_012': {
    typeId: 'task_012',
    name: 'Hamilton Anxiety Rating Scale (HAM-A)',
    pageTitle: 'Hamilton Anxiety Rating Scale',
    description: 'Assessment of anxiety symptoms using the standardized HAM-A scale',
    category: 'assessment',
    estimatedDuration: 15,
    component: TaskHamiltonAnxiety,
    isActive: false
  },
  'task_013': {
    typeId: 'task_013',
    name: 'Open Journaling',
    pageTitle: 'Open Journaling',
    description: 'A flexible writing task with custom instructions from your therapist',
    category: 'homework',
    estimatedDuration: 20,
    component: TaskOpenEnded,
    isActive: true
  },
  'task_014': {
    typeId: 'task_014',
    name: 'Reality Check Moment',
    pageTitle: 'Reality Check Moment',
    description: 'Help slow down catastrophic thoughts by separating facts from fears and re-evaluating how likely the feared outcome truly is',
    category: 'cbt',
    estimatedDuration: 8,
    component: TaskRealityCheck,
    isActive: true
  },
  'task_015': {
    typeId: 'task_015',
    name: 'Photo Journal',
    pageTitle: 'Photo Journal',
    description: 'Take a photo and write your thoughts about it',
    category: 'homework',
    estimatedDuration: 15,
    component: TaskPhotoJournal,
    isActive: true
  },
  'task_016': {
    typeId: 'task_016',
    name: 'Gratitude Journal: Three Good Things (Day 1)',
    pageTitle: 'Three Good Things - Day 1',
    description: 'Reflect on the positive moments and experiences from your day',
    category: 'gratitude',
    estimatedDuration: 10,
    component: TaskGratitudeJournaling,
    isActive: true
  },
  'task_017': {
    typeId: 'task_017',
    name: 'Gratitude Journal: Three Good Things (Day 2)',
    pageTitle: 'Three Good Things - Day 2',
    description: 'Reflect on accomplishments, humor, and people you\'re thankful for',
    category: 'gratitude',
    estimatedDuration: 10,
    component: TaskGratitudeJournaling,
    isActive: true
  },
  'task_018': {
    typeId: 'task_018',
    name: 'Gratitude Journal: Three Good Things (Day 3)',
    pageTitle: 'Three Good Things - Day 3',
    description: 'Focus on gratitude, moments of joy, and meaningful memories',
    category: 'gratitude',
    estimatedDuration: 10,
    component: TaskGratitudeJournaling,
    isActive: true
  },
  'task_019': {
    typeId: 'task_019',
    name: 'Gratitude Journal: Three Good Things (Day 4)',
    pageTitle: 'Three Good Things - Day 4',
    description: 'Acknowledge good things, special moments, and personal achievements',
    category: 'gratitude',
    estimatedDuration: 10,
    component: TaskGratitudeJournaling,
    isActive: true
  },
  'task_020': {
    typeId: 'task_020',
    name: 'Gratitude Journal: Three Good Things (Day 5)',
    pageTitle: 'Three Good Things - Day 5',
    description: 'Notice interesting experiences, gratitude for others, and fun moments',
    category: 'gratitude',
    estimatedDuration: 10,
    component: TaskGratitudeJournaling,
    isActive: true
  },
  'task_021': {
    typeId: 'task_021',
    name: 'Gratitude Journal: Three Good Things (Day 6)',
    pageTitle: 'Three Good Things - Day 6',
    description: 'Capture memorable moments, humor, and your favorite parts of the day',
    category: 'gratitude',
    estimatedDuration: 10,
    component: TaskGratitudeJournaling,
    isActive: true
  },
  'task_022': {
    typeId: 'task_022',
    name: 'Gratitude Journal: Three Good Things (Day 7)',
    pageTitle: 'Three Good Things - Day 7',
    description: 'Reflect on happiness, acts of kindness, and personal successes',
    category: 'gratitude',
    estimatedDuration: 10,
    component: TaskGratitudeJournaling,
    isActive: true
  },
  'task_023': {
    typeId: 'task_023',
    name: 'Song of the Day',
    pageTitle: 'Song of the Day',
    description: 'Pick one song that best describes your day and tell your therapist why',
    category: 'wellness',
    estimatedDuration: 10,
    component: TaskSongOfTheDay,
    isActive: true
  },
  'task_024': {
    typeId: 'task_024',
    name: 'Step Outside & Capture a Moment',
    pageTitle: 'Step Outside & Capture a Moment',
    description: 'Find a nearby green space or just step outside your home. Take one photo of something you notice.',
    category: 'mindfulness',
    estimatedDuration: 10,
    component: TaskStepOutside,
    isActive: true
  }
};

// Helper functions
export const getActiveTasks = () => Object.values(TASK_REGISTRY).filter(task => task.isActive);

export const getTaskById = (typeId) => TASK_REGISTRY[typeId];

export const getTasksByCategory = (category) => 
  Object.values(TASK_REGISTRY).filter(task => task.category === category && task.isActive);

export const isTaskActive = (typeId) => TASK_REGISTRY[typeId]?.isActive || false;

// Dynamic category generation from tasks
export const getTaskCategories = () => {
  const categories = {};
  Object.values(TASK_REGISTRY).forEach(task => {
    if (task.isActive && task.category) {
      if (!categories[task.category]) {
        // Generate display name from category key
        categories[task.category] = task.category
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      }
    }
  });
  return categories;
};

// Backward compatibility - can be removed later
export const TASK_CATEGORIES = getTaskCategories();
